module.exports = "function rule(user, context, callback) {\n  if (!user.email_verified) {\n    return callback(new UnauthorizedError('Please verify your email before logging in.'));\n  } else {\n    return callback(null, user, context);\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/pages/jp/homepage/rule-templates/email-verified.js.txt
// module id = 1435
// module chunks = 0